// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "about") return "css/about.universalHub.css?v=6243be250071feb7e550";
	if (chunkId === "landing") return "css/landing.universalHub.css?v=81458dd99a8e2ed578b9";
	if (chunkId === "releases") return "css/releases.universalHub.css?v=0d4f9ac9eb7a1b296c1a";
	if (chunkId === "moviePlaceholder") return "css/moviePlaceholder.universalHub.css?v=7330878fbfa550e4e744";
	// return url for filenames based on template
	return undefined;
};